import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFunctionService } from '../../services/common-function.service';
import { Router } from '@angular/router';
import { DataManipulateService } from '../../services/data-manipulate.service';

@Component({
  selector: 'app-default-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss'
})
export class DefaultHeaderComponent implements OnInit {
  isSearchActive = false;

  @Output() toggleSidebar = new EventEmitter<void>();
  activateSearch() {
    this.isSearchActive = true;
  }

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }



  deactivateSearch() {
    this.isSearchActive = false;
  }
  constructor(public common: CommonFunctionService, private route: Router, public data: DataManipulateService) { }
  ngOnInit(): void { }

  goToPage(route: string) {
    this.route.navigateByUrl(route)
  }

}
